import React from 'react';

import Form from "../Form";



const ContactNewView = ({organizationId, contactGroupId, onSuccess = () => null, onSubmitting = () => null, onError = () => null}) => 
  <Form organizationId={organizationId} contact={{contactContactGroupId: contactGroupId, name: ""}} onSubmitting={onSubmitting} onError={onError} onSuccess={onSuccess} />

export default ContactNewView;